module.exports = __webpack_public_path__ + "static/img/product_14.111c588.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_14.jpg
// module id = f5w1
// module chunks = 2